import React, { ChangeEvent, FunctionComponent } from "react";

import { Caption, GridColumnCount, GridGapSize, GridLayout, GridLayoutItem } from "@multiweb/reactComponents";
import { IAttrValue } from "@multiweb/types/contracts";
import { LOC_BASIC_CONDITION, LOC_CHANGED_ATTRIBUTE, LOC_COMMENT, LOC_NEW_VALUE, LOC_NEW_WF_STATE, LOC_SUPERIOR_CLASS, LOC_VALUE_ATTRIBUTE } from "../../../../../../locKeys";
import { getUiWorkflowMutableObject } from "../../../../../../utils";
import { CONST_ACTION_COMMENT_AT, CONST_ACTION_CONDITION_AT, CONST_SET_OBJECT_ATTRIBUTE_ATTR_NAME_AT, CONST_SET_OBJECT_ATTRIBUTE_MASTER_ATTR_NAME_AT, CONST_SET_OBJECT_ATTRIBUTE_MASTER_CLASS_NAME_AT, CONST_SET_OBJECT_ATTRIBUTE_VALUE_EL } from "../../../../../../workflowParser/constants";
import { Edit, Memo, TextLOVEdit } from "../../../../components";
import { MAX_INPUT_LENGTH_L } from "../constants";
import { ActionPageProps } from "../types";

const getNewWfStateAttrs = ["Stav_dokladu", "Kod"];

export const SetObjectAttributePage: FunctionComponent<ActionPageProps> = ({ hostKey, properties, updateAction }) => {
    const { workflow } = getUiWorkflowMutableObject(hostKey);

    const getNewWfState = (results: readonly IAttrValue[] | undefined) => {
        if (results) {
            updateAction([
                { key: CONST_SET_OBJECT_ATTRIBUTE_ATTR_NAME_AT, value: "Stav_WF" },
                { key: CONST_SET_OBJECT_ATTRIBUTE_VALUE_EL, value: results[1].toString() },
                { key: CONST_SET_OBJECT_ATTRIBUTE_MASTER_CLASS_NAME_AT, value: "WFStavy" },
                { key: CONST_SET_OBJECT_ATTRIBUTE_MASTER_ATTR_NAME_AT, value: "Kod" }]);
        }
    };

    const onAttrNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_SET_OBJECT_ATTRIBUTE_ATTR_NAME_AT, value:  e.target.value }]);
    };

    const onValueChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_SET_OBJECT_ATTRIBUTE_VALUE_EL, value: e.target.value }]);
    };

    const onMasterClassNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_SET_OBJECT_ATTRIBUTE_MASTER_CLASS_NAME_AT, value: e.target.value }]);
    };

    const onMasterAttrNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_SET_OBJECT_ATTRIBUTE_MASTER_ATTR_NAME_AT, value: e.target.value }]);
    };

    const onConditionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateAction([{ key: CONST_ACTION_CONDITION_AT, value: e.target.value }]);
    };

    const onCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateAction([{ key: CONST_ACTION_COMMENT_AT, value: e.target.value }]);
    };

    return (
        <GridLayout columns={GridColumnCount.one} gap={GridGapSize.two}>
            <GridLayoutItem>
                <Caption required locKey={LOC_CHANGED_ATTRIBUTE}/>
                <Edit qa={LOC_CHANGED_ATTRIBUTE} required maxLength={MAX_INPUT_LENGTH_L} value={properties[CONST_SET_OBJECT_ATTRIBUTE_ATTR_NAME_AT]} onChange={onAttrNameChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_NEW_VALUE} />
                <Edit qa={LOC_NEW_VALUE} maxLength={MAX_INPUT_LENGTH_L} value={properties[CONST_SET_OBJECT_ATTRIBUTE_VALUE_EL]} onChange={onValueChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_SUPERIOR_CLASS} />
                <Edit qa={LOC_SUPERIOR_CLASS} maxLength={MAX_INPUT_LENGTH_L} value={properties[CONST_SET_OBJECT_ATTRIBUTE_MASTER_CLASS_NAME_AT]} onChange={onMasterClassNameChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_VALUE_ATTRIBUTE} />
                <Edit qa={LOC_VALUE_ATTRIBUTE} maxLength={MAX_INPUT_LENGTH_L} value={properties[CONST_SET_OBJECT_ATTRIBUTE_MASTER_ATTR_NAME_AT]} onChange={onMasterAttrNameChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_NEW_WF_STATE} />
                <TextLOVEdit
                    qa={LOC_NEW_WF_STATE}
                    value={properties[CONST_SET_OBJECT_ATTRIBUTE_VALUE_EL]}
                    formName="FRM.WFStavy.WFStavy"
                    attributeNames={getNewWfStateAttrs}
                    condition={`(Trida=null or Trida.Nazev_tridy = '${workflow.className}')`}
                    maxLength={MAX_INPUT_LENGTH_L}
                    onFormClose={getNewWfState}
                    isEditable={false}
                    {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_BASIC_CONDITION} />
                <Memo qa={LOC_BASIC_CONDITION} value={properties[CONST_ACTION_CONDITION_AT]} onChange={onConditionChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_COMMENT} />
                <Memo qa={LOC_COMMENT} value={properties[CONST_ACTION_COMMENT_AT]} onChange={onCommentChange} {...{ hostKey }} />
            </GridLayoutItem>
        </GridLayout>
    );
};
